export default __webpack_public_path__ + "static/media/google.17675d09.svg";